import {h, Fragment} from "preact"
export default function CheckboxTile({ value, selected, onChange, className }) {
    const isText = isNaN(Number(value));

    return (
        <div
            class={`
                ns-facet-tile-element 
                ${selected ? 'ns-facet-tile-element--active' : ''}
                ${isText ? 'ns-facet-tile-element--text' : 'ns-facet-tile-element--number'}
            `}
        >
            <div class="ns-facet-tile-element__wrapper">
                <input class="ns-facet-tile-element__input" type="checkbox" name="us_size" id="Filter-us_size-1" value="5" onChange={onChange} />
                <span class="ns-facet-tile-element__text">
                    <span class="facet-checkbox__text-label font-secondary mono-md lg-mono-sm">{value}</span>
                </span>
            </div>
        </div>
    )
}